module.exports = __webpack_public_path__ + "static/media/illustration.9e394bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/isotope-images/illustration.png
// module id = 161
// module chunks = 0